/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Keys
 */

module.exports = {
  BACKSPACE:  8,
  TAB:        9,
  RETURN:    13,
  ALT:       18,
  ESC:       27,
  SPACE:     32,
  PAGE_UP:   33,
  PAGE_DOWN: 34,
  END:       35,
  HOME:      36,
  LEFT:      37,
  UP:        38,
  RIGHT:     39,
  DOWN:      40,
  DELETE:    46,
  COMMA:    188,
  PERIOD:   190,
  A:         65,
  Z:         90,
  ZERO:      48,
  NUMPAD_0:  96,
  NUMPAD_9: 105
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/fixed-data-table/internal/Keys.js
 ** module id = 546
 ** module chunks = 0
 **/